import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u983891880/domains/military.thepurpleoctopus.in/hbuilds/source/pov-main/src/components/sections/capabilities/equipment/EquipmentCategoryDetail.tsx");
